var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-form-group",
    { attrs: { label: "Frame Colour" } },
    [
      _c("b-form-select", {
        attrs: { options: _vm.colourOptions },
        scopedSlots: _vm._u([
          {
            key: "first",
            fn: function () {
              return [
                _c("b-form-select-option", { attrs: { value: null } }, [
                  _vm._v("Any"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.selectedColourId,
          callback: function ($$v) {
            _vm.selectedColourId = $$v
          },
          expression: "selectedColourId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }